import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { IconEye, IconEyeOff } from '@tabler/icons';
import { LOIN_REQUEST_SUCCESS, REMOVE_COOKIE } from '../../../redux/types';
import ApiConfig from '../../../api/ApiConfig';
import Loading from '../../../components/loading/Loading';
import { toggleShowingPassword } from '../../../utils/function/toggleShowingPassword';

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isShowPassword, setIsShowPassword] = useState(false);
  useEffect(() => {
    dispatch({ type: REMOVE_COOKIE });
  }, [dispatch]);
  // ----------------------------------------------------------------------------------->
  const initialValues = {
    // initial Values input felids
    email: '',
    password: '',
  };
  // ----------------------------------------------------------------------------------->
  const validationSchema = Yup.object({
    email: Yup.string()
      .required(`email required`)
      .min(6, `The email you should not be less than 6 characters`)
      .max(40, `The email you must not than 40 characters`)
      .email('Invalid email format'),
    password: Yup.string()
      .required(`password required`)
      .min(6, `The password you should not be less than 6 characters`)
      .max(20, `The password you must not than 20 characters`),
  });
  // ----------------------------------------------------------------------------------->
  const onSubmit = (values) => {
    // handel to login as dashboard
    setIsLoading(true);
    const data = {
      email: values.email,
      password: values.password,
    };
    ApiConfig.post(`auth/login`, data)
      .then((res) => {
        setIsLoading(false);
        if (res.status === 200) {
          toast.success('Successful logged in to control panel');
          const { role, access_token, name } = res?.data?.data;
          //save data as cookie storage
          dispatch({
            type: LOIN_REQUEST_SUCCESS,
            payload: {
              accessToken: access_token,
              refreshToken: '',
              role: role,
              email: values.email,
              username: name,
            },
          });
          if (role === 'super' || role === 'admin') {
            // check is super admin or main
            navigate('/hero');
          } else {
            toast.warn(
              "can't access panel role is not admin a, please try again"
            );
          }
        } else {
          toast.error(
            'There is a problem that the login was not successful, please try again'
          );
        }
      })
      .catch((err) => {
        setIsLoading(false);
        if (err?.response?.status === 422) {
          Object.entries(err?.response?.data?.msg).forEach(([key, value]) => {
            toast.error(value[0]);
          });
        } else {
          toast.error('error email or password please try again');
        }
      });
  };
  // ----------------------------------------------------------------------------------->
  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });
  return (
    <>
      <Loading isLoading={isLoading} />
      <div className='page page-center'>
        <div className='container-tight py-4'>
          <div className='text-center'>
            <Link to='/' className='navbar-brand navbar-brand-autodark'>
              <img
                className='rounded-3 p-1'
                width='150'
                src='./assets/images/logo.png'
                alt='logo alpha'
              />
            </Link>
          </div>
          <form
            className='card card-md'
            autoComplete='off'
            onSubmit={formik.handleSubmit}
          >
            <div className='card-body'>
              <h2 className='card-title text-center mb-4'>
                Login to your account
              </h2>
              <div className='mb-3'>
                <label className='form-label' htmlFor='email'>
                  Email address
                </label>
                <input
                  type='email'
                  name='email'
                  inputMode='email'
                  id='email'
                  className='form-control'
                  placeholder='example@gmail.com'
                  {...formik.getFieldProps('email')}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className='text-error'>{formik.errors.email}</div>
                ) : null}
              </div>
              <div className='mb-2'>
                <label className='form-label' htmlFor='password'>
                  Password
                </label>
                <div className='input-group input-group-flat'>
                  <input
                    type={`${isShowPassword ? 'text' : 'password'}`}
                    name='password'
                    id='password'
                    inputMode='text'
                    className='form-control'
                    placeholder='***************'
                    autoComplete='off'
                    {...formik.getFieldProps('password')}
                  />
                  {formik.touched.password && formik.errors.password ? (
                    <div className='text-error'>{formik.errors.password}</div>
                  ) : null}
                  <span
                    className='input-group-text'
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      toggleShowingPassword(isShowPassword, setIsShowPassword)
                    }
                  >
                    {isShowPassword ? <IconEye /> : <IconEyeOff />}
                  </span>
                </div>
              </div>
              <div className='mb-2'>
                <label className='form-check'>
                  <input type='checkbox' className='form-check-input' />
                  <span className='form-check-label'>
                    Remember me on this device
                  </span>
                </label>
              </div>
              <div className='form-footer'>
                <button type='submit' className='btn btn-primary w-100'>
                  Sign in
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
